<template>
  <div class="why-mikmak">

    <div id="whitespace" class="whitespace"></div>

    <!-- TITLE -->
    <h1 class="why-mikmak-heading">Why MikMak?</h1>

    <div class="why-mikmak-table">

      <div class="table-row">
        <span class="table-column blank"></span>
        <span class="table-column header blank">Brands sold at retailers</span>
        <span class="table-column header blank">DTC Brands</span>
      </div>

      <div class="table-row">
        <span class="table-column legend"><i>Problem</i>: User clicks or swipes from media</span>
        <span class="table-column">No PDP data & no control over experience.</span>
        <span class="table-column">70-90% of users bounce from site.</span>
      </div>

      <div class="table-row">
        <span class="table-column legend"><i>Solution</i>: MikMak Attach</span>
        <span class="table-column">Connect to retailers like Amazon, Target, Walmart, Kroger, Instacart, CVS and more.</span>
        <span class="table-column">Connect to your own DTC Cart like Demandware, Shopify, Magento, Hybris and more.</span>
      </div>

      <div class="table-row">
        <span class="table-column legend"><i>The MikMak ROI</i></span>
        <span class="table-column">Custom Audiences, 15-200% lift, 25-40% higher ROAS, 1.5X lift in CPA efficiency and 2X lift in CTR.</span>
        <span class="table-column">Reduce bounce rates by 20%, 20-40% lift in add to cart rate, 1.5X lift in CPA efficiency and 2X lift in CTR.</span>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  data() {
    return {
      List: [
        {
          name: 'MikMak Studios',
          icon: '',
          iconClass: '',
          buttonText: 'Request a quote',
          videoUrl: 'https://s3.amazonaws.com/attach.mikmak.tv/videos/mikmak-sizzle.mp4',
          text: 'Full-service production specialized in fun, short-form product videos.'
        },
        {
          name: 'MikMak Academy',
          icon: '',
          iconClass: '',
          buttonText: 'Enroll in a course',
          text: 'Immersive, custom-designed courses to upskill brands for success in the rapidly evolving world of social video commerce. Courses include:'
        }
      ]
    }
  },
  components: {},
  mounted() {
    // if (!window.sr) window.sr = ScrollReveal()
    // window.sr.reveal('.why-mikmak', { delay: 250, duration: 500 })
  },
  methods: {},
  computed: {},
  watch: {}
}
</script>

<style scoped>

  .why-mikmak {
    display: block;
    margin: 40px 0;
    margin-top: -40px;
    margin-bottom: 75px;
  }

  .whitespace {
    height: 80px;
  }

  .why-mikmak-heading {
    font-family: "Work Sans",sans-serif;
    font-weight: normal;
    letter-spacing: 2px;
    font-size: 14px;
    margin: 0 auto;
    display: block;
    text-align: center;
    color: #333;
    text-transform: uppercase;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 32px;
  }

  .table-row {
    display: block;
    margin: 0 auto;
    text-align: center;
    width: 100%;
  }

  .table-column {
    width: 20%;
    display: inline-block;
    background: #f6f6f6;
    margin: 8px;
    border-radius: 1px;
    font-size: 14px;
    padding: 8px;
    text-align: left;
    vertical-align: top;
    font-family: "Work Sans", sans-serif;
  }

  .table-column i {
    font-style: normal;
    color: #ee50b3;
    font-weight: bold;
  }

  .table-column.legend {
    color: #ee50b3;
  }

  .table-column.header {
    font-weight: bold;
  }

  .table-column.blank {
    background: none;
  }

  @media only screen and (max-width: 450px) {
    .why-mikmak {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// WhyMikMak.vue?1a64f0f2